// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_13VLB){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_1bXem .dualColumn_2hJJx{display:flex;align-content:space-between}.nsAddressForm_1bXem .dualColumn_2hJJx .firstCol_2tfbi{margin-right:20px}.optional_3XHPC{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_13VLB",
	"nsAddressForm": "nsAddressForm_1bXem",
	"dualColumn": "dualColumn_2hJJx",
	"firstCol": "firstCol_2tfbi",
	"optional": "optional_3XHPC"
};
module.exports = exports;
